<template>
  <aside class="app-notice status-action-panel" v-if="!vehicleStatusInfo.isButton && hasActions">
    <p>
      Before you transact with the DMV for your registration you need to take the following step(s):
    </p>
    <ul>
      <li v-for="(item, p) in vehicleStatusInfo.statusActions" :key="`action${p}`">
        {{ item.actionInstruction }}
      </li>
    </ul>
    <p>
      After you take the above mentioned step(s) please wait 24 hours before you re-check your registration status.
    </p>
  </aside>
</template>



<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import * as COMMONS from "../../../store/_commons";

defineOptions({
  name: 'StatusActionPanel',
});

const store = useStore();

// Computed properties
const vehicleStatusInfo = computed(() => store.getters[COMMONS.VEHICLE_STATUS_INFO]);

const hasActions = computed(() => {
  return (
    vehicleStatusInfo.value &&
    vehicleStatusInfo.value.statusActions &&
    vehicleStatusInfo.value.statusActions.length > 0
  );
});
</script>

<style lang="scss" scoped>
.status-action-panel {
  --whitespace: 1.5em;
  margin-bottom: var(--whitespace);
  max-width: unset;
  p:first-child {
    @extend %font-sans-bold;
  }
  p:last-child {
    padding-bottom: 0.75em;
  }
  ul {
    margin-left: var(--whitespace);
    li {
      list-style: initial;
      margin-bottom: calc(var(--whitespace) * 0.5);
    }
  }

  @supports (margin-block: 1em) {
    margin-block-end: var(--whitespace);
    ul {
      margin-inline-start: var(--whitespace);
      li {
        margin-block-end: calc(var(--whitespace) * 0.5);
      }
    }
  }
}
</style>
